export const clampCrosshair = (value, min, max) => Math.max(min, Math.min(max, value));

export const getCandleCrosshairPoint = (event, bounds) => {
  if (!event || !bounds) return null;
  const rawX = event.activeCoordinate?.x ?? event.chartX;
  const rawY = event.chartY ?? event.activeCoordinate?.y;
  if (!Number.isFinite(rawX) || !Number.isFinite(rawY)) return null;
  return {
    x: clampCrosshair(rawX, bounds.left, bounds.right),
    y: clampCrosshair(rawY, bounds.top, bounds.bottom),
    index: event.activeTooltipIndex ?? null,
  };
};
